export const CUTOFF_HOUR_UTC = 6;
export const STORY_COUNT = 5;

export type BriefingStatus =
  | "published"
  | "insufficient"
  | "failed"
  | "missing";

export type BriefingStorySnapshot = {
  id: number;
  position: number;
  articleId: number | null;
  title: string;
  summary: string;
  link: string;
  imageUrl: string | null;
  provider: string;
  normalizedTitle: string;
  sentiment: number;
  publishedAt: Date;
};

export type DailyBriefingResponse =
  | {
      status: "published";
      issueDate: string;
      introText: string | null;
      introSource: string | null;
      stories: BriefingStorySnapshot[];
      previousPublishedDate: string | null;
      nextPublishedDate: string | null;
      latestPublishedDate: string | null;
    }
  | {
      status: "insufficient" | "failed";
      issueDate: string;
      storyCount: number;
      failureReason: string | null;
      previousPublishedDate: string | null;
      nextPublishedDate: string | null;
      latestPublishedDate: string | null;
    }
  | {
      status: "missing";
      issueDate: string;
      previousPublishedDate: string | null;
      nextPublishedDate: string | null;
      latestPublishedDate: string | null;
    };

/**
 * Parse a YYYY-MM-DD string to UTC midnight as a Date object.
 */
export function parseIssueDate(dateStr: string): Date {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
}

/**
 * Format a UTC Date to YYYY-MM-DD.
 */
export function formatIssueDate(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * Format a YYYY-MM-DD string to a human-readable display date (e.g. "Monday, January 1, 2024").
 */
export function formatDisplayDate(dateStr: string): string {
  const [year, month, day] = dateStr.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
}
